import React from 'react';
import Badge from '../../../common/Badge';
import { iconSportCssClass } from '../../../data/utils';
import CategoryCollapse from './CategoryCollapse';
import { getLabel } from '../../../InitData';
import { usePrematchData } from '../../PrematchDataFetcher';
import { useRouteData } from '../../../router/RouteDataProvider';

export default function MenuSportCollapse(props) {
    const prematchData = usePrematchData();
    const routeData = useRouteData();

    const categoryById = new Map();
    routeData.tournamentsData.tournaments.forEach(t => {
        const s = prematchData.sportById[t.sportRef];
        if (s == null) {
            return;
        }

        const categoryId = t.categoryRef;
        const c = s.categoryById[t.categoryRef];
        if (c == null) {
            return;
        }

        if (!categoryById.has(categoryId)) {
            categoryById.set(categoryId, {
                ...c,
                tournaments: [],
                tournamentsCount: 0
            });
        }
        const category = categoryById.get(c.id);
        category.tournaments.push(t);
        category.tournamentsCount++;
    });

    const sport = props.data;
    const icon = iconSportCssClass(sport.id, sport.iconClass);
    let eventsCount = sport.tournamentsCount;
    if (eventsCount === 0) {
        eventsCount = null;
    }

    let categories = Array.from(categoryById.values());

    return (
        <div className="c_16">
            <div className="c_16_1">
                <div className={"c_16_1_1 " + icon}></div>
                <div className="c_16_1_2" onClick={props.close}>{sport.descrizione}</div>
                <div className="c_16_1_3">
                    {sport.isLive &&
                        <Badge desc={getLabel('general.live')} />
                    }
                    <div className="c_16_1_3_1">{eventsCount}</div>
                </div>
            </div>
            {categories.map(c =>
                <CategoryCollapse key={c.id} data={c} />
            )}
        </div>
    );
}
